import { useTranslation } from 'react-i18next'

export function EnforcerOneTab(): JSX.Element {
  const { t } = useTranslation()
  return (
    <main className="w-full">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center min-h-screen py-2">
          <img
            src="https://b2bpublic.s3.us-west-2.amazonaws.com/images/logotipob2b.svg"
            srcSet="https://b2bpublic.s3.us-west-2.amazonaws.com/images/logotipob2b.svg"
            alt="B2B images"
            loading="lazy"
          />
          <p>{t('enforcerOneTab.message')}</p>
        </div>
      </div>
    </main>
  )
}
